/**
 * ActionDecisionToggle (T-11 sub-component of SaveScreen/SK-SAVE,
 * DS-1g-05 §5.1 [§2 row 1]) — AC-1g-04.
 *
 * The single human toggle that decides routing: `"action"` → Skill #2
 * `upsert`; `"decision"` → Skill #3 `raise`/`resolve`. `value` starts as
 * `null` (owned by the caller) and this component contains NO code path
 * that selects a value on its own — it only ever reports the tap the
 * human made (§4.7 no-default rule). No route is constructible until the
 * caller's `value` is non-null.
 */

export type ActionDecisionValue = "action" | "decision";

export interface ActionDecisionToggleProps {
  value: ActionDecisionValue | null;
  onChange: (value: ActionDecisionValue) => void;
}

export function ActionDecisionToggle({ value, onChange }: ActionDecisionToggleProps) {
  return (
    <div>
      <p class="save-chip-group-hint">Type</p>
      <div data-testid="action-decision-toggle" role="radiogroup" aria-label="Action or Decision">
        <button
          type="button"
          data-testid="action-decision-toggle-action"
          aria-pressed={value === "action"}
          onClick={() => onChange("action")}
        >
          Action
        </button>
        <button
          type="button"
          data-testid="action-decision-toggle-decision"
          aria-pressed={value === "decision"}
          onClick={() => onChange("decision")}
        >
          Decision
        </button>
      </div>
    </div>
  );
}
